module.exports = __webpack_public_path__ + "static/media/Bird10.8375e76f.jpg";